import { useContext, useEffect, useState } from "react"
import { SocketContext } from "../../context/SocketContext"
import { useLocation, useNavigate } from "react-router-dom"
import WaitingRoom from "../../compomnents/WaitingRoom"
import MeetingRoom from "../../compomnents/MeetingRoom"
import instance from "../../../../../axios/instance"


export default function MeetingContainer() {

    const socket = useContext(SocketContext)
    const navigate = useNavigate()
    const location = useLocation()

    const [loading, setLoading] = useState(false)
    const [token, setToken] = useState("")

    const [meetingStatus, setMeetingStatus] = useState(null)

    useEffect(() => {
        
        getAgoraToken()
        //socket.emit("refresh_test", location.state)

        socket.emit("meeting_check", location.state)

        //getMeetingLinkResponse()
        socket.on("meeting_check_response", data => {
            console.log(data);
            setMeetingStatus(data.status)
        })

    }, [])

    function getAgoraToken() {
        setLoading(true)
        instance.post("/telemedicine/agora/token", {
            uid: location.state.meeting.doctor_id,
            channelName: location.state.meeting.channel_name
        })
        .then(response => {
            console.log(response.data); 

            setToken(response.data.token)
            setLoading(false)
        })
        .catch(error => {
            console.log(error.response.data);
            setLoading(false)
        })
    }

    if (loading || !token) {
        return <div>Getting token</div>
    }


    return (
        <div>
            {
                meetingStatus && (
                    meetingStatus === "wait" ? 
                    <WaitingRoom meetingInfo={location.state} /> : 
                    <MeetingRoom token={token} meetingData={location.state} />
                )
            }
        </div>
    )
}